// ─────────────────────────────────────────────────────────────────────────────
// THE FIXED CHROME ON EVERY DOORLYDESK PAGE, AND THE SPACE IT TAKES.
//
// 🚨 A FIXED LAUNCHER SITS ON TOP OF WHATEVER IS UNDER IT, AND IT WAS SITTING ON
// A BUTTON. AdminLayout mounts AdminAIAssistant on every admin page: a pill at
// the bottom-right holding the daily-debrief star and the report-a-bug glyph,
// zIndex 999. The Messages inbox puts its Send Reply button at the bottom-right
// of the thread pane, which is the same corner — so on the borrower and partner
// Messages pages the send button was behind the widget and could not be clicked.
//
// 🔑 THE FOOTPRINT IS DECLARED ONCE AND BOTH SIDES READ IT. The launcher
// positions itself from these numbers and a page reserving clearance subtracts
// the same ones. Two copies would mean the day somebody makes the pill taller,
// the clearance stays where it was and the button goes back under it — which is
// exactly how this reached production: the numbers lived only in the launcher,
// so nothing else could know about them.
//
// ⚠️ THIS IS NOT A GENERAL LAYOUT SYSTEM AND SHOULD NOT BECOME ONE. It describes
// one widget. A page that needs clearance asks for it explicitly, because most
// admin pages do not put anything in that corner and reserving a gutter on all
// of them would be a visible change to screens nobody reported a problem with.
// ─────────────────────────────────────────────────────────────────────────────

/** The launcher pill: distance from the viewport edges, and its size. */
export const AI_LAUNCHER = Object.freeze({
  bottom: 24,
  right: 24,
  height: 52,
  // 52 (star) + 1 (divider) + 46 (bug) + 2×2 border.
  width: 103,
});

// ── 🚨 THERE IS NO CLEARANCE CONSTANT, AND THAT IS A DECISION ─────────────
//
// There was one, briefly: AI_LAUNCHER_CLEARANCE, so a page could pad its
// bottom-right corner by the pill's footprint. The Messages inbox used it, then
// stopped — Jesse's answer to "the Send button is behind the widget" was to not
// load the widget on those pages, which is AdminLayout's `hideAssistant`.
//
// ⚠️ IT IS REMOVED RATHER THAN LEFT FOR LATER. Nothing reads it, and an export
// nothing reads is a second mechanism for one problem — the next person with a
// button in that corner would find two answers and no way to tell which is the
// live one. If reserving space turns out to be the right answer for some page,
// the arithmetic is one line from the footprint above.
/**
 * The panel opens above the pill, so it starts where the pill ends.
 * ⚠️ DERIVED RATHER THAN THE LITERAL 88 IT USED TO BE, which was the same
 * arithmetic written out by hand in the one place that happened to need it.
 */
export const AI_PANEL_BOTTOM = AI_LAUNCHER.bottom + AI_LAUNCHER.height + 12;
